import * as React from 'react'

const SvgToolIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.562 1.25a6.125 6.125 0 00-3.375 1l4 4a1.313 1.313 0 01.125 1.875A1.312 1.312 0 016.437 8L2.312 4A6.15 6.15 0 001.25 7.563a6.338 6.338 0 006.312 6.312 6.81 6.81 0 001.625-.188l4.188 4.188a3.138 3.138 0 104.438-4.438L13.625 9.25c.127-.532.19-1.078.188-1.625a6.25 6.25 0 00-6.25-6.375zm5 6.313c0 .444-.063.885-.187 1.312l-.188.688.5.5 4.188 4.187a1.8 1.8 0 01.563 1.313 1.7 1.7 0 01-.563 1.312 1.813 1.813 0 01-2.625 0l-4.188-4.188-.5-.5-.687.188a4.754 4.754 0 01-1.313.188A5.169 5.169 0 014 11.124a4.769 4.769 0 01-1.5-3.562c0-.465.064-.928.187-1.375l2.75 2.75a2.588 2.588 0 003.688.125A2.588 2.588 0 009 5.375l-2.75-2.75a4.036 4.036 0 011.25-.188 5.17 5.17 0 013.563 1.438 5.306 5.306 0 011.5 3.688z"
      fill="#163250"
    />
  </svg>
)

export default SvgToolIcon
